import { ICONS } from "../../../assets/icons/index";

export const connectWhatsapp = [
  {
    id: 1,
    title: "Connect WhatsApp Business API",
    subtitle: " Connect WhatsApp Business Platform (API)",
    description:
      "Connect your number with WhatsApp Business API and start engaging with customers efficiently.",
    content: "WhatsApp has been Connected Successfully",
    button: "Connect with Facebook",
    button1: "Connected",
    key: "connect_wapp_buss_api",
  },
  {
    id: 2,
    title: "Start Business Verification",
    content: "Business Verified Successfully",
    subtitle: "WhatsApp Business Verification",
    description:
      "Verify your business with Meta to build trust and gain access to advanced WhatsApp features.",
    button: "Start Business Verification",
    button1: "Business Verified Successfully",
    key: "start_buss_verification",
  },
  {
    id: 3,
    title: "Add Payment Method",
    content: "Payment Added Successfully",
    subtitle: "Payment Method",
    description:
      "Set up your preferred payment method to manage messaging costs smoothly.",
    button: "Manage Payment",
    button1: "Payment Added Successfully",
    key: "add_payment_method",
  },
  {
    id: 4,
    title: "Create Campaign",
    subtitle: "Send Broadcast",
    content: "Campaign Created Successfully",
    description:
      "Create and launch highly engaging WhatsApp campaigns. Leverage templates, automation, and audience targeting to maximize customer engagement.",
    button: "Create Campaign",
    button1: "Campaign Created Successfully",
    key: "is_campaign_created",
  },
  {
    id: 5,
    title: "Apply Blue Tick Verification",
    subtitle: "Blue Tick Verification",
    description:
      "Apply for verification and enhance customer trust with a recognized business profile.",
    button: "Contact Sales",
    button1: "Verfified Successfully",
    key: "green_tick_verified",
  },
];
